export default __webpack_public_path__ + "static/media/logo_blank.a696fbd7.png";